import { ItemInstance } from '@headless-tree/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, Heart, IconFormIcons } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { ListSectionLifeAreaHeader } from 'shared/components/ui/section-header-life-area';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';
import { DataType } from 'shared/types/data-type';
import { LifeArea } from 'shared/types/life-area';

import * as Styled from './life-area-header.style';

export type LifeAreaHeaderProps = {
  item: ItemInstance<InternalTreeItem>;
  lifeArea: LifeArea | undefined;
  denseFormat?: boolean;
};

export const LifeAreaHeader: React.FC<LifeAreaHeaderProps> = ({
  item,
  lifeArea,
  denseFormat,
}) => {
  const { t } = useTranslation();

  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    item.isExpanded() ? item.collapse() : item.expand();
  };

  const title = lifeArea?.name ?? t('general.sections.life-areas.other.title');

  return (
    <Styled.HeaderContainer
      $denseFormat={denseFormat}
      data-component-type={DataType.LifeArea}
      data-id={item.getItemData().sourceId}
      data-title={title}
    >
      <ListSectionLifeAreaHeader
        id={item.getItemData().sourceId}
        name={title}
        icon={lifeArea ? IconFormIcons[lifeArea.iconName] : Heart}
        color={lifeArea?.color ?? undefined}
        isFrozen={!!lifeArea?.frozenAt}
        image={lifeArea?.visionPreview?.image}
      />
      <IconButton
        icon={ChevronLeft}
        onClick={toggleOpen}
        rotation={item.isExpanded() ? -90 : 0}
        color={Colors.Default}
      />
    </Styled.HeaderContainer>
  );
};
